import { useEffect, useRef, useState } from 'react';

import FileInfo from '@/types/fileInfo';

function useMediaDuration(file?: FileInfo) {
  const mediaRef = useRef<HTMLAudioElement | HTMLVideoElement | null>(null);
  const [loadedDuration, setLoadedDuration] = useState<{
    path: string;
    value: string;
  } | null>(null);
  const isMedia =
    !!file &&
    (file.file_type.startsWith('audio') || file.file_type.startsWith('video'));
  const mediaDuration = !isMedia
    ? null
    : loadedDuration?.path === file.file_storage_path
      ? loadedDuration.value
      : undefined;

  useEffect(() => {
    if (file && isMedia) {
      const mediaElement = document.createElement(
        file.file_type.startsWith('audio') ? 'audio' : 'video',
      );
      mediaElement.src = file.file_storage_path;
      mediaRef.current = mediaElement;
      mediaElement.onloadedmetadata = () => {
        const duration = mediaElement.duration;
        const minutes = Math.floor(duration / 60);
        const seconds = Math.floor(duration % 60);
        const formattedDuration = `${minutes}:${
          seconds < 10 ? '0' : ''
        }${seconds}`;
        setLoadedDuration({
          path: file.file_storage_path,
          value: formattedDuration,
        });
      };
    }
  }, [file, isMedia]);

  return mediaDuration;
}

export default useMediaDuration;
